import { computed } from "vue";
import useCreateComponentConfig, { EStates, EVariants } from "../../../composables/useCreateComponentConfig.js";
import focus from "@/ui/plushComponents/constants/focus";
import { SIZES } from "@/ui/ts/types/Sizes";
var ETabsTriggerElements = /* @__PURE__ */ ((ETabsTriggerElements2) => {
  ETabsTriggerElements2["TRIGGER"] = "TRIGGER";
  return ETabsTriggerElements2;
})(ETabsTriggerElements || {});
export default function useTabsTriggerConfig(props) {
  const rootClasses = useTriggerConfig(props);
  return {
    rootClasses
  };
}
function useTriggerConfig(props) {
  const { setBase, addBaseState, addSize, setDefault, getClasses } = useCreateComponentConfig();
  setBase(
    "TRIGGER" /* TRIGGER */,
    /* tw */
    `flex justify-center items-center gap-2 -mb-[2px] max-w-[80%]
        text-neutral-tertiary
        border-b-2 border-neutral-subtlest 
        transition-colors duration-200 ease-linear`
  );
  addSize(
    "TRIGGER" /* TRIGGER */,
    SIZES.MEDIUM,
    /* tw */
    "min-h-2xl px-base py-sm label-md"
  );
  addSize(
    "TRIGGER" /* TRIGGER */,
    SIZES.LARGE,
    /* tw */
    "min-h-3xl p-base label-lg"
  );
  setDefault("TRIGGER" /* TRIGGER */, EVariants.DEFAULT, SIZES.LARGE);
  addBaseState(
    "TRIGGER" /* TRIGGER */,
    EStates.HOVER,
    /* tw */
    `lg:hover:border-brand-accent-on-dark hover:text-comp-high-contrast`
  );
  addBaseState(
    "TRIGGER" /* TRIGGER */,
    EStates.FOCUSED,
    /* tw */
    `${focus}`
  );
  addBaseState(
    "TRIGGER" /* TRIGGER */,
    EStates.SELECTED,
    /* tw */
    `text-comp-high-contrast`
  );
  addBaseState(
    "TRIGGER" /* TRIGGER */,
    EStates.DISABLED,
    /* tw */
    `text-disabled border-neutral-subtlest hover:!border-neutral-subtlest hover:!text-disabled`
  );
  addBaseState(
    "TRIGGER" /* TRIGGER */,
    EStates.PRESSED,
    /* tw */
    `active:hover:text-neutral-tertiary active:hover:border-neutral-subtlest`
  );
  const tabsClasses = computed(() => {
    return getClasses("TRIGGER" /* TRIGGER */, void 0, props.size, props.state, props.disabled);
  });
  return tabsClasses.value;
}
